module.exports = __webpack_public_path__ + "media/tycho2t3_80_grey_my.8f414c63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/sky_box/tycho2t3_80_grey_my.jpg
// module id = 1098
// module chunks = 0